import React from 'react';

import Menu from '@gogame/ui/Menu';
import IconButton from '@gogame/ui/IconButton';
import { SortIcon } from '@gogame/ui/Icon';

const SortingMenu = ({ children, onChange, orderDir, orderBy }) => {
  return (
    <Menu anchor={<IconButton icon={<SortIcon />} tooltip={'Sort by'} />}>
      {React.Children.map(children, (child) => {
        const { id } = child.props;
        const selected = orderBy === id;
        return React.cloneElement(child, {
          selected: selected,
          onChange: (direction) => onChange(id, direction),
          orderDir: selected ? orderDir : '',
        });
      })}
    </Menu>
  );
};
export default SortingMenu;
